import React from 'react'
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, ModalBody, ModalFooter, Row } from 'reactstrap';
import { LabelInputSpecimen, LabelInputAbbreviationSpecimen, ModalButtonCancel } from '../../constant';

export const FormSpecimen = (props) => {

    const {
        handleInputChange, validaciones, methodAction, name, abbreviation,
    } = props;

    const {
        name_valid, abbreviation_valid
    } = validaciones;

    return (
        <Form className="" role="form" onSubmit={methodAction}>
            <div className='form-section'>
                 <Row>
                    <Col md="6">
                        <FormGroup>
                            <Label className="label-admision">{ LabelInputSpecimen } <span className='f-16' style={ { color: "#0079C7" } }>*</span></Label>
                            <Input
                                type="text"
                                name="name"
                                value={name}
                                autoComplete="nope"
                                onChange={handleInputChange}
                                invalid={name_valid}
                                className='input-admision'

                            />
                            <FormFeedback>Debe contener 3 ó más caracteres</FormFeedback>
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        <FormGroup>
                            <Label className="label-admision">{ LabelInputAbbreviationSpecimen } <span className='f-16' style={ { color: "#0079C7" } }>*</span></Label>
                            <Input
                                type="text"
                                name="abbreviation"
                                value={abbreviation}
                                autoComplete="off"
                                onChange={handleInputChange}
                                invalid={abbreviation_valid}
                                className='input-admision'

                            />
                            <FormFeedback>Debe contener 3 o más caracteres</FormFeedback>
                        </FormGroup> 
                    </Col>
                </Row>


            </div>
               
            
        </Form>
    )
}
